import { gql } from "@apollo/client";
import { ORG_USER_FIELDS } from "./OrgUser";
import { ORG_ROLE_FIELDS } from "./OrgRole";
import { CORE_PROJECT_FIELDS } from "./project";
import { DOCUMENT_FIELDS } from "./Document";
import { CORE_GANG_MEMBER_FIELDS } from "./GangMember";
import { USER_FIELDS } from "./User";
import { PERMIT_TEMPLATE_FIELDS } from "./PermitTemplate";
import { CORE_PERMIT_TYPE_FIELDS } from "./PermitType";

export const PERMIT_TO_DIG_DATA_FIELDS = gql`
  fragment PermitToDigDataFields on PermitToDig {
    comments
    validityDuration {
      from
      to
      hoursFrom
      hoursTo
      endsNextDay
    }
    contractor
    subContractor
    locationOfWork
    worksDescription
    noAffectedServices
    affectedServices
    asBuiltRequired
  }
`;

export const PERMIT_TO_DIG_LIST_FIELDS = gql`
  fragment PermitToDigListFields on PermitToDig {
    id
    number
    validityDuration {
      from
      to
      hoursFrom
      hoursTo
      endsNextDay
    }
    locationOfWork
    worksDescription
    createdBy {
      id
      userId
      user {
        id
        firstName
        lastName
        email
        phoneNumber
        displayName
      }
    }
    state {
      key
      name
    }
    areas {
      polygon {
        coordinates
        crs
        type
      }
      type {
        key
        name
      }
      comments
    }
    permitAssignments {
      id
      orgRole {
        id
        roleId
        displayName
      }
      orgUser {
        id
        userId
        user {
          id
          displayName
        }
      }
    }
    asBuiltRequired
    type {
      id
      name
    }
  }
`;

export const PERMIT_TO_DIG_ASSOCIATED_ENTITIES = gql`
  ${CORE_PROJECT_FIELDS}
  ${PERMIT_TO_DIG_DATA_FIELDS}
  ${ORG_USER_FIELDS}
  ${USER_FIELDS}
  ${ORG_ROLE_FIELDS}
  ${DOCUMENT_FIELDS}
  ${CORE_GANG_MEMBER_FIELDS}
  fragment PermitToDigAssociatedEntities on PermitToDig {
    signatures {
      type
      dateSignedUtc
      orgRole {
        ...OrgRoleFields
      }
      orgUser {
        ...OrgUserFields
      }
      date
      isAbsent
      gangMember {
        id
      }
      signatureUrl
      declaration
      signatory {
        name
        roleName
        phoneNumber
      }
    }
    sitePhotos {
      id
      fileUrl
      comments
      dateCreated
      type {
        key
        name
      }
      createdBy {
        id
        user {
          ...UserFields
        }
      }
      affectedServiceName
      noPhotoReason
    }
    gangMembers {
      ...CoreGangMemberFields
    }
    documents {
      ...DocumentFields
    }
    calibrationCertificate {
      catSerialNumber
      catCalibrationDate
      catCalibrationDueDate
      gennySerialNumber
      gennyCalibrationDate
      gennyCalibrationDueDate
    }
    locationLogs {
      id
      user {
        ...OrgUserFields
      }
      date
      latitude
      longitude
    }
    areas {
      polygon {
        coordinates
        crs
        type
      }
      type {
        key
        name
      }
      comments
    }
  }
`;

export const PERMIT_TO_DIG_ALL_FIELDS = gql`
  ${CORE_PROJECT_FIELDS}
  ${PERMIT_TO_DIG_DATA_FIELDS}
  ${ORG_USER_FIELDS}
  ${PERMIT_TO_DIG_ASSOCIATED_ENTITIES}
  ${PERMIT_TEMPLATE_FIELDS}
  ${CORE_PERMIT_TYPE_FIELDS}
  ${ORG_ROLE_FIELDS}
  fragment PermitToDigAllFields on PermitToDig {
    id
    number
    permittedTriggers
    ...PermitToDigDataFields
    ...PermitToDigAssociatedEntities
    createdBy {
      ...OrgUserFields
    }
    state {
      key
      name
    }
    project {
      ...CoreProjectFields
      boundaries {
        coordinates
        crs
        type
      }
      permitRegisters {
        id
        title
        description
        permitTypes {
          ...CorePermitTypeFields
          template {
            ...PermitTemplateFields
          }
        }
      }
    }
    stateChangeLogs {
      source
      destination
      trigger
      dateTimeUtc
      orgUser {
        ...OrgUserFields
      }
      comment
    }
    permitAssignments {
      id
      orgRole {
        ...OrgRoleFields
      }
      orgUser {
        ...OrgUserFields
      }
      assignedBy {
        ...OrgUserFields
      }
      dateAssignedUtc
    }
    eightPointCheckList {
      items
      declaration
    }
    fieldValues {
      fieldKey
      displayValue
      ... on TextPermitFieldValue {
        stringValue: value
      }
      ... on BooleanPermitFieldValue {
        booleanValue: value
      }
      ... on NumberPermitFieldValue {
        numberValue: value
      }
      ... on DatePermitFieldValue {
        dateValue: value
      }
    }
  }
`;
